import committee from "../../src/components/committees/pages/committee";
import documents from "../../src/components/committees/pages/documents"
import messages from "../../src/components/committees/pages/messages"
import members from "../../src/components/committees/pages/members"
import itemgroups from "../../src/components/committees/pages/itemgroups"
import items from "../../src/components/committees/pages/items"
import responsibilities from "../../src/components/committees/pages/responsibilities"
import committeeIndex from "../../src/components/committees/index";


export default 	[
    {
        path:"all",
        component:committeeIndex,
        meta:{
            AuthRequired:true,
            Breadcrumb:'Commissies'
        },
    },
    {
        path:":id/all",
        component:committeeIndex,
        meta:{
            AuthRequired:true,
        },
        //name:'committees index'
    },
	{
        path:"create",
        component:committee,
        meta:{
            AuthRequired:true
        },
    },
    {
        path:":id/edit",
        component:committee,
        meta:{
            AuthRequired:true
        },
    },
    {
        path:":id/view",
        component:committee,
        meta:{
            AuthRequired:true,
        },
    },
    {
        path:":id/documents",
        component:documents,
        meta:{
            Breadcrumb:'Documenten',
            AuthRequired:true
        },
    },
    {
        path:":id/itemgroups",
        component:itemgroups,
        meta:{
            Breadcrumb:'Itemgroepen',
            AuthRequired:true
        },
    },
    {
        path:":id/items",
        component:items,
        meta:{
            Breadcrumb:'Items',
            AuthRequired:true
        },
    },
    {
        path:":id/members",
        component:members,
        meta:{
            Breadcrumb:'Leden',
            AuthRequired:true
        },
    },
    {
        path:":id/messages",
        component:messages,
        meta:{
            Breadcrumb:'Berichten',
            AuthRequired:true
        },
    },
    {
        path:":id/responsibilities",
        component:responsibilities,
        meta:{
            Breadcrumb:'Taken',
            AuthRequired:true
        },
    },
];
